import { DatePicker, Space } from 'antd';

interface Props {
  handleDateValue: Function;
}

const { RangePicker } = DatePicker;

const dateFormat = 'YYYY-MM-DD';

const DatePickerr = ({ handleDateValue }: Props) => {
  return (
    <Space direction="vertical" size={12} className="busk-datePicker">
      <RangePicker
        placeholder={['YYYY.MM.DD', 'YYYY.MM.DD']}
        onChange={(date: any, datestring: [string, string]) => {
          handleDateValue(datestring);
        }}
        format={dateFormat}
      />
    </Space>
  );
};

export default DatePickerr;
